// === COMMON ===
export const COMMON_DEPARTMENTS = "/Common/departments";
export const COMMON_UTILITIES = '/Common/utilities';
export const COMMON_SYSTEMROLES = '/Common/system/roles';
export const COMMON_ROLES = "/Common/roles";
export const COMMON_SHIFTS = "/Common/shifts";

// === USER ===
export const USER_PROFILE_ENDPOINT = "/User/profile";
export const USER_MY_PROFILE_ENDPOINT = "/User/me";
export const USER_ENDPOINT = "/User";
export const USER_PROFILE_ID_ENDPOINT = (id: string) => `/User/profile/${id}`;
export const USER_ID_ENDPOINT = (id: string) => `/User/${id}`;
export const USER_ROLE_ID_ENDPOINT = (id: string) => `/User/role/${id}`;
export const USER_UNDER_MANAGER_ENDPOINT = () => `/User/undermanager`;
export const USER_PROFILE_CREATE_ENDPOINT = "/profile";
export const USER_REGISTRATION_ENDPOINT = "/User/registration";

// === ATTENDANCE ===
export const ATTENDANCE = "/Attendance";
export const ATTENDANCE_SCHEDULE = "/Attendance/schedule";
export const ATTENDANCE_SCHEDULE_CREATE = "/Attendance/schedule/create";
export const ATTENDANCE_SCHEDULE_CONFIGURATION = "/Attendance/schedule/configuration";
export const ATTENDANCE_DELETE_SCHEDULE_CONFIGURATION = (id: string) => `/Attendece/schedule/configuration${id}`;
export const ATTENDANCE_SUMMARY = (year: number, month: number) => `${ATTENDANCE}/summary/${year}/${month}`;
export const ATTENDANCE_VIEW_MYSELF_TEAM = (id: string, year: number, month: number) =>`/Attendance/overview/${id}/${year}/${month}`;
export const ATTENDANCE_APPROVE_INDIVIDUAL = (id: string, year: number, month: number) => `Attendance/approve/user/${id}/year/${year}/month/${month}`;
export const ATTENDANCE_APPROVE_MYTEAM  = (id: string, year: number, month: number) => `/Attendance/approve/myteam/${id}/year/${year}/month/${month}`;

// === USERSCHEDULE ===
export const USERSCHEDULE_GET_SCHEDULE_ATTENDANCE = (id: string, year: number, month: number) =>  `UserSchedule/attendance/${id}/year/${year}/month/${month}`;
export const USERSCHEDULE_CREATE_SCHEDULE = "/UserSchedule/create";
export const USERSCHEDULE_GET_SCHEDULE_CONFIGURATION = (id: string, year: number, month: number) => `/UserSchedule/configuration/${id}/year/${year}/month/${month}`;
export const USERSCHEDULE_DELETE_SCHEDULE_CONFIGURATION = (id: string) => `/UserSchedule/configuration${id}`;


// === ENTITY SCHEDULE ===
export const ENTITY_SCHEDULE_CREATE = "/EntitySchedule/create";
export const ENTITY_SCHEDULE_PRIMARY = "/EntitySchedule/User";
export const ENTITY_SCHEDULE_SECONDARY = "/EntitySchedule/Receiver";

// === PATIENT ===
export const PATIENT_PROFILE = "/Patient/profile";
export const PATIENT = "/Patient";
export const PATIENT_PROFILE_ID = (id: string) => `/Patient/profile/${id}`;
export const PATIENT_REGISTRATION = "/Patient/registration";
export const PATIENT_REGISTRATION_APPROVE = (id: string) => `/Patient/registration/approve/${id}`;
export const PATIENT_REGISTRATION_REVIEW = "/Patient/registration/review";




// === COMPENSATION ===
export const COMPENSATION_GETPDF_PAYSLIP = (id: string, year: number, month: number) => `/Compensation/${id}/payslip/${year}/${String(month).padStart(2, "0")}`; 
export const COMPENSATION_CALCULATE_CTC = "/Compensation/breakup";
export const COMPENSATION_GENERATE_PAYROLL = (year: number, month: number) => `/Compensation/pay/generate/${year}/${month}`;
export const COMPENSATION_CALCULATE_MONTHLY_PAYOUT = (year: number, month: number) => `/Compensation/pay/summary/${year}/${month}`; 


// === Student Registration ===
export const STUDENT_REGISTRATION = "/StudentRegistration/upsert"
export const STUDENT_GET_REGISTRATION = "/StudentRegistration"
export const STUDENT_CLASSES = "/Student/classes"
export const DOCUMENT_UPLOAD = "/documents/upload"
// /api/documents/upload

// /api/StudentRegistration/upsert


export const EMAIL_VERIFICATION = (email: string) => `/StudentRegistration/generate/otp?email=${encodeURIComponent(email)}`;


export const EMAIL_VERIFICATION_VERIFY = (email: string, otp: string) => `/StudentRegistration/verify/otp?email=${encodeURIComponent(email)}&otp=${encodeURIComponent(otp)}`;

export const STUDENT_GETREGISTRATION_EMAIL = (email: string) => `/StudentRegistration/${encodeURIComponent(email.trim())}`;


export const STUDENT_PROFILE_WITH_PARENTS = (studentId: string) =>
  `/StudentRegistration/${encodeURIComponent(studentId)}/profile/withparents`;


export const STUDENT_GETCOURSE = "/Student/courses"


export const STUDENT_UPLOAD_PROFILE_PICTURE = (studentId: string) =>
  `/Student/${studentId}/ProfilePicture`;

export const STUDENT_GETBUS_ROUTE = "/Student/bus/route"

export const STUDENT_POST_INITIAL_DATA = "/StudentInitialData";

export const STUDENT_POST_ENQUIRY = "/Enquiry/upsert"

export const STUDENT_GET_SCHOOL_CLASSES = "/student/class/school"


export const ENQUIRY_PAYMENT_STATUS = (enquiryNumber: string) => `/Enquiry/payment/status/${enquiryNumber}`;
export const STUDENT_GET_ENQUIRY = (enquiryNumber: string) => `/Enquiry/${enquiryNumber}`;
export const ENQUIRY_TRACK_BY_EMAIL_DOB = "/Enquiry/track";

// CXC/CSEC exam registration - a separate submission from the "Apply Now"
// enquiry funnel above.
export const CXC_REGISTRATION_SUBMIT = "/CxcRegistration/submit";
// The subject grid that form offers - staff-maintained, active rows only.
// form=GCP is the Grand Cayman Private (public, external candidates) list.
export const CXC_SUBJECTS_PUBLIC = "/CxcSubject/active?form=GCP";
// Sittings, deadlines and fees for the public (GCP) form - the server's one copy.
export const CXC_OPTIONS = "/CxcSettings/options?form=GCP";
// The email check before a CXC submit: a 6-digit code, then a token the submit spends.
export const CXC_OTP_SEND = "/CxcRegistration/otp/send";
export const CXC_OTP_VERIFY = "/CxcRegistration/otp/verify";
export const ENQUIRY_OTP_SEND = "/Enquiry/otp/send";
export const ENQUIRY_OTP_VERIFY = "/Enquiry/otp/verify";

// Student Application

export const STUDENT_POST_APPLICATION = "/StudentApplication/upsert"
export const  DOCUMENT_GET_ALL = "/StudentApplication/document/type"
export const STUDENT_POST_DOCUMENTS = (docId: string, applicationId: string) => `/StudentDocument/upload/doc/${docId}/application/${applicationId}`;
export const STUDENT_STATUS ="/Enquiry/validate"
export const STUDENT_EMAIL_STATUS = (emailId: string) => `/Enquiry/validate/${emailId}`;
export const STUDENT_OFFER_ACCEPTANCE = (applicationId: string) => `/StudentApplication/${applicationId}/offeracceptance`;
export const STUDENT_UNPAID_INVOICES = (studentId: string) => `/StudentApplication/${studentId}/invoices/unpaid`;
export const STUDENT_DOCUMENT_LIST = "/StudentDocument/list";

export const STUDENT_CLASS_FEES = "/student/class/fee/structures"

// === EVENT ===
export const EVENT_PUBLISHED = "/Event/published";
export const EVENT_DOWNLOAD_IMAGE = (id: string) => `/Event/download/image/${id}`;

// === CAREERS ===
export const CAREERS_JOBS_LIST = "/PublicCareers/jobs";
export const CAREERS_JOB_DETAIL = (id: string) => `/PublicCareers/jobs/${id}`;
export const CAREERS_APPLY = "/PublicCareers/apply";







// === SCHOOL CALENDAR ===
export const SCHOOL_CALENDAR_PUBLIC = (from: string, to: string) =>
  `/school/calendar/public?from=${from}&to=${to}`;

// === TUITION FEES ===
// The same endpoint the admin Fee Settings screen uses; anonymous callers get
// approved rows only (see StudentFeeController.GetAcademicFeeStructure).
export const ACADEMIC_FEE_STRUCTURE = `/StudentFee/academic/fee/structure`;
